export const PDF_COLORS = {
  primary: [49, 65, 91],    // navy-300
  secondary: [233, 100, 111], // coral-400
  muted: [124, 124, 124],   // grey-500
  background: [248, 248, 248], // grey-100
  text: [22, 22, 22],       // near black
  white: [255, 255, 255],
} as const;

export const PDF_STYLES = {
  table: {
    bodyStyles: {
      font: 'helvetica',
      fontSize: 9,
      textColor: PDF_COLORS.text,
    },
    headStyles: {
      fillColor: PDF_COLORS.primary,
      textColor: PDF_COLORS.white,
      fontSize: 9,
      font: 'helvetica',
      fontStyle: 'bold',
    },
    alternateRowStyles: {
      fillColor: [250, 250, 250],
    },
  },
} as const;